export default function DashboardKPICards({ totalAsignados, vencenHoy, vencen7Dias, vencidos }) {
  return (
    <div className='dashboard-kpi-grid'>
      <div className='kpi-card kpi-card--total'>
        <div className='kpi-card-info'>
          <span className='kpi-card-label'>Total Asignados</span>
          <span className='kpi-card-value'>{totalAsignados}</span>
          <span className='kpi-card-change kpi-card-change--neutral'>
            <i className='bi bi-folder2-open'></i> Siniestros activos
          </span>
        </div>
        <div className='kpi-card-icon kpi-card-icon--total'>
          <i className='bi bi-clipboard-data-fill'></i>
        </div>
      </div>

      <div className='kpi-card kpi-card--hoy'>
        <div className='kpi-card-info'>
          <span className='kpi-card-label'>Vencen Hoy</span>
          <span className='kpi-card-value'>{vencenHoy}</span>
          <span className={`kpi-card-change ${vencenHoy > 0 ? 'kpi-card-change--down' : 'kpi-card-change--up'}`}>
            <i className={`bi ${vencenHoy > 0 ? 'bi-exclamation-triangle-fill' : 'bi-check-circle-fill'}`}></i>
            {vencenHoy > 0 ? 'Requiere atención' : 'Sin pendientes'}
          </span>
        </div>
        <div className='kpi-card-icon kpi-card-icon--hoy'>
          <i className='bi bi-clock-fill'></i>
        </div>
      </div>

      <div className='kpi-card kpi-card--manana'>
        <div className='kpi-card-info'>
          <span className='kpi-card-label'>Próx. 7 Días</span>
          <span className='kpi-card-value'>{vencen7Dias}</span>
          <span className={`kpi-card-change ${vencen7Dias > 0 ? 'kpi-card-change--down' : 'kpi-card-change--up'}`}>
            <i className={`bi ${vencen7Dias > 0 ? 'bi-calendar-week-fill' : 'bi-check-circle-fill'}`}></i>
            {vencen7Dias > 0 ? 'Próximos a vencer' : 'Sin pendientes'}
          </span>
        </div>
        <div className='kpi-card-icon kpi-card-icon--manana'>
          <i className='bi bi-calendar-week-fill'></i>
        </div>
      </div>

      <div className='kpi-card kpi-card--vencidos'>
        <div className='kpi-card-info'>
          <span className='kpi-card-label'>Vencidos</span>
          <span className='kpi-card-value'>{vencidos}</span>
          <span className={`kpi-card-change ${vencidos > 0 ? 'kpi-card-change--down' : 'kpi-card-change--up'}`}>
            <i className={`bi ${vencidos > 0 ? 'bi-arrow-up' : 'bi-check-circle-fill'}`}></i>
            {vencidos > 0 ? 'Atención urgente' : 'Todo al día'}
          </span>
        </div>
        <div className='kpi-card-icon kpi-card-icon--vencidos'>
          <i className='bi bi-exclamation-octagon-fill'></i>
        </div>
      </div>
    </div>
  );
}
